/**
 * Locale-aware formatting hooks. Money/weight/date logic lives in src/lib (pure, tested);
 * these bind it to the current language.
 */
import { useMemo } from 'react'
import { useI18n } from './context'
import { formatPaise, type Paise } from '@/lib/money'
import { formatGrams, type Grams } from '@/lib/weight'
import { formatIstDate, formatIstDateTime, formatIstTime, formatRelative } from '@/lib/ist'

const countFmt = {
  hi: new Intl.NumberFormat('hi-IN'),
  en: new Intl.NumberFormat('en-IN'),
}

export function useFormat() {
  const { locale } = useI18n()
  return useMemo(
    () => ({
      money: (p: Paise) => formatPaise(p),
      weight: (g: Grams) => formatGrams(g),
      count: (n: number) => countFmt[locale].format(n),
      date: (d: Date | string | number) => formatIstDate(d, locale),
      dateTime: (d: Date | string | number) => formatIstDateTime(d, locale),
      time: (d: Date | string | number) => formatIstTime(d, locale),
      relative: (d: Date | string | number) => formatRelative(d, locale),
    }),
    [locale],
  )
}
